import { createSignal } from "solid-js";

export interface MapManeuverClick {
  tick: number;
  eventId: number;
  eventType: string;
}

const [mapManeuverClick, setMapManeuverClick] = createSignal<MapManeuverClick | null>(null);

/** Latest map-marker click. The tick advances even when the same maneuver is clicked again. */
export function lastMapManeuverClick(): MapManeuverClick | null {
  return mapManeuverClick();
}

export function noteMapManeuverClick(eventId: number, eventType: string | null): void {
  const id = Number(eventId);
  if (!Number.isFinite(id) || id <= 0) return;
  setMapManeuverClick((prev) => ({
    tick: (prev?.tick ?? 0) + 1,
    eventId: id,
    eventType: (eventType ?? "").trim().toUpperCase(),
  }));
}
